import React from 'react';
import {connect} from "react-redux";
import ClearButton from "./common/ClearButton";

const CloseablePanel=(props)=>{
    return(
        <div>
        {props.filters.clearResults[props.type] ? '' :
            (
                 <div>
                    {props.children}
                </div>
            )
        }
        </div>)
};

const mapStateToProps=(state)=>({filters: state.filters});
const ConnectedCloseablePanel=connect(mapStateToProps)(CloseablePanel);
export default ConnectedCloseablePanel;